<div class="toolbar">
  <div class="tabs">
    <button type="button" data-tab="Open" [class.active]="tab() === 'Open'" (click)="onTabClick('Open')">
      {{'admin_support.lbl_tab_open' | translate}}
    </button>
    <button type="button" data-tab="Closed" [class.active]="tab() === 'Closed'" (click)="onTabClick('Closed')">
      {{'admin_support.lbl_tab_closed' | translate}}
    </button>
  </div>

  <input
    type="text"
    class="case-search"
    [value]="member() ?? ''"
    (input)="onSearchInput($any($event.target).value)"
    placeholder="{{'admin_support.lbl_search_placeholder' | translate}}"
  />
</div>

<div class="table-scroll">
  <table class="case-table">
    <thead>
      <tr>
        <th *ngIf="isCaseNumberEnabled">{{'admin_support.lbl_col_case_number' | translate}}</th>
        <th>{{'admin_support.lbl_col_member' | translate}}</th>
        <th>{{'admin_support.lbl_col_heading' | translate}}</th>
        <th>{{'admin_support.lbl_col_channel' | translate}}</th>
        <th *ngIf="tab() === 'Closed'" class="col-center">{{'admin_support.lbl_col_rating' | translate}}</th>
        <th *ngIf="tab() === 'Open'">{{'admin_support.lbl_col_waiting' | translate}}</th>
        <th class="col-center">{{'admin_support.lbl_col_age' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="emptyStateKey() as key" class="empty-row">
        <td [attr.colspan]="isCaseNumberEnabled ? 6 : 5">{{key | translate}}</td>
      </tr>
      <tr *ngFor="let c of cases()" (click)="onRowClick(c.supportId)">
        <td *ngIf="isCaseNumberEnabled" class="case-number-cell">{{ c.supportNumber ? '#' + c.supportNumber : '—' }}</td>
        <td>
          <div class="member-cell">
            <span class="name">{{c.memberName}}</span>
          </div>
        </td>
        <td class="heading-cell">
          {{c.topic}}
          <span class="new-case-dot" *ngIf="c.needsAdminReview" title="{{'admin_support.lbl_stat_new' | translate}}" attr.aria-label="{{'admin_support.lbl_stat_new' | translate}}"></span>
        </td>
        <td><span class="channel-chip">{{c.channel}}</span></td>
        <td *ngIf="tab() === 'Closed'" class="rating-cell">{{c.rating ?? '—'}}</td>
        <td *ngIf="tab() === 'Open'">
          <span class="waiting-pill" [class.yes]="c.isWaitingForAdminReply" [class.no]="!c.isWaitingForAdminReply">
            <span class="dot"></span>
            {{ c.isWaitingForAdminReply ? ('admin_support.lbl_yes' | translate) : ('admin_support.lbl_no' | translate) }}
          </span>
        </td>
        <td class="age-cell">{{ (c.lastCommentDate ?? c.supportCreatedOn) | osloDate }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="pagination" *ngIf="totalPages() > 1">
  <button type="button" class="page-btn" [disabled]="!hasPrevPage()" (click)="onPrevPage()">‹</button>
  <span class="page-info">{{'admin_support.lbl_page_of' | translate:{ page: page(), total: totalPages() } }}</span>
  <button type="button" class="page-btn" [disabled]="!hasNextPage()" (click)="onNextPage()">›</button>
</div>
